import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PercentIcon from '../../assets/target/images/PercentIcon.svg';
import { t } from '../../lang';
import RequestService from '../../services/RequestService';
import { appSlice } from '../../store/slices';
import Button from '../Button';
import { Icons } from '../Icon/Icon';

import './FeePaymentConfiguration.scss';

const FeePaymentConfiguration = () => {
	const [minFeeForDefaultMethod, setMinFeeForDefaultMethod] = useState(0);

	const dispatch = useDispatch();

	const headerContent = () => {
		return (
			<div
				style={{
					background: 'rgba(4, 85,163, 1)',
					color: 'white',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					justifyContent: 'center',
					height: '150px',
					paddingLeft: '24px',
					paddingBottom: '24px',
					position: 'relative',
				}}
			>
				<img
					src={PercentIcon}
					style={
						{
							// position: 'absolute',
							// top: '10%',
							// transform: 'translateY(-10%)',
						}
					}
				/>
				<div
					style={{
						position: 'absolute',
						top: '60%',
						display: 'flex',
						flexDirection: 'column',
						gap: '12px',
						zIndex: '2',
					}}
				>
					<h1 style={{ fontSize: '24px' }}>{t('Transaction fee')}</h1>
					<p style={{ color: 'rgba(255,255,255,0.6)' }}>{t('Learn about transaction fees')}</p>
				</div>
			</div>
		);
	};

	const openInfoModal = () => {
		setTimeout(() => {
			dispatch(
				appSlice.actions.addModal({
					headerBackground: 'rgba(4, 85,163, 1)',
					headerContent: headerContent(),
					buttonStyles: { color: 'rgba(255,255,255, 0.6)', background: 'rgba(255,255,255, 0.3)' },
					tag: 'PaymentConfigurationInfo',
					isOpen: true,
					height: '70%',
				})
			);
		}, 1000);
	};

	const enterFee = () => {
		dispatch(
			appSlice.actions.addModal({
				title: t('Transaction fee'),
				tag: 'PaymentConfiguration',
				isOpen: true,
				height: '80%',
				leftButtons: [{ icon: Icons.QUESTIONMARK, onClick: openInfoModal }],
				outsideParams: { minFeeForMethod: minFeeForDefaultMethod },
			})
		);
	};

	useEffect(() => {
		RequestService.GetMinFeeForDefaultMethod().then(response => setMinFeeForDefaultMethod(response?.MinFee || 0));
	}, []);

	return (
		<Button className='FeePaymentConfiguration' styleType='white' iconAfter={'ARROW_CHEVRON'} onClick={enterFee}>
			{t('Transaction fee')}
		</Button>
	);
};

export default FeePaymentConfiguration;
